import { createContext, FC, PropsWithChildren } from 'react';
import CreateBonusStore from '../store';
import { usePatchBonus, usePostBonus } from '../../../../queries/bonus/mutations';

const store = new CreateBonusStore();
const CreateBonusContext = createContext(store);

export const CreateBonusContextProvider: FC<PropsWithChildren> = ({ children }) => {
  return <CreateBonusContext.Provider value={store}>{children}</CreateBonusContext.Provider>;
};

export const useCreateBonus = () => {
  const postMutation = usePostBonus();
  const patchMutation = usePatchBonus();

  const createBonus = async (companyId: string) => {
    const requestBody = store.buildPostRequest();
    return postMutation.mutateAsync({ companyId, requestBody });
  };

  const updateBonus = async (bonusId: string) => {
    const requestBody = store.buildPatchRequest();
    return patchMutation.mutateAsync({ bonusId, requestBody });
  };

  return {
    newBonus: store,
    createBonus,
    updateBonus,
    createIsPending: postMutation.isPending,
    updateIsPending: patchMutation.isPending
  };
};
